import React, { Fragment } from 'react';
import Wrapper from 'components/Wrapper';
import GenericDialog from 'components/GenericDialog';
import ThemeButton from 'components/atoms/ThemeButton';
import AutoComplete from 'components/atoms/AutoComplete';
import OutlinedButton from 'components/atoms/OutlinedButton';
import DragzoneBoxComponent from 'components/atoms/DragzoneBox/DragzoneBoxComponent';
import { uploadDocumentTypesComponent } from './UploadDocumentTypes';
import * as S from './styles';
import { Typography } from '@material-ui/core';

const UploadDocumentModalComponent = ({
  open,
  onClose,
  mainFile,
  setMainFile,
  addDocument,
  documentTypesOptions,
  isLoadingOptions,
  typeDocument,
  setTypeDocument,
  isLoading,
  documentName,
}: uploadDocumentTypesComponent) => {
  function removeAfterParenthesis(text) {
    const index = text.indexOf('(');
    return index !== -1 ? text.slice(0, index).trim() : text;
  }

  return (
    <GenericDialog
      open={open}
      title="Adicionar documentos"
      onClose={onClose}
      maxWidth="sm"
      DialogAction={() => (
        <Wrapper flex justify="end" width="100%" gap="md">
          <OutlinedButton onClick={onClose} disabled={isLoading}>
            Cancelar
          </OutlinedButton>
          <ThemeButton
            onClick={addDocument}
            disabled={isLoading || !typeDocument || !mainFile.length}
            loading={isLoading}
          >
            Adicionar
          </ThemeButton>
        </Wrapper>
      )}
    >
      <Wrapper width="100%" gap="lg" flex direction="column">
        <Typography>
          Você está fazendo o upload do documento:{' '}
          <strong>&quot;{documentName}&quot;</strong>. Certifique-se de enviar o
          arquivo adequado para continuar o processo.
        </Typography>

        <Wrapper width="100%">
          <AutoComplete
            minHeight="58px"
            label="Tipo de documento*"
            name="typeDocument"
            disabled
            value={
              typeDocument
                ? {
                    value: typeDocument,
                    label: removeAfterParenthesis(
                      documentTypesOptions?.find(
                        e => e.value === Number(typeDocument)
                      )?.label || ''
                    ),
                    name: removeAfterParenthesis(
                      documentTypesOptions?.find(
                        e => e.value === Number(typeDocument)
                      )?.label || ''
                    ),
                  }
                : null
            }
            options={documentTypesOptions}
            onChange={e => {
              setTypeDocument(e?.value);
            }}
            isLoading={isLoadingOptions}
          />
        </Wrapper>

        {!!typeDocument && (
          <Fragment>
            <Wrapper width="100%">
              <S.UploadSectionTitle>Documento principal</S.UploadSectionTitle>
              <S.UploadSectionDescription>
                Permitido anexar apenas 1 documento.
              </S.UploadSectionDescription>
              <DragzoneBoxComponent
                fileState={mainFile}
                setFileState={setMainFile}
              />
            </Wrapper>
          </Fragment>
        )}
      </Wrapper>
    </GenericDialog>
  );
};

export default UploadDocumentModalComponent;
